import React from 'react';

import { ReactComponent as PointerIcon } from 'pages/Teachers/Home/assets/pointer-icon.svg';

import styles from './styles.module.scss';

const StartEmptyBox = ({ stepNumber, description, icon, actionLabel }) => {
  return (
    <div className={styles.card}>
      <div className={styles.iconWrapper}>{icon}</div>
      <span className={styles.stepLabel}>{stepNumber}</span>
      <p className={styles.description}>{description}</p>

      {actionLabel && (
        <button className={styles.textAction}>
          {actionLabel}
          <span>
            <PointerIcon />
          </span>
        </button>
      )}
    </div>
  );
};

export default StartEmptyBox;
